export default "__VITE_ASSET__DenpR6Ch__"